import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getReceiptTypes = async () => {
  return await request.get(
    `/RentPlace/receipt/type`,
    {},
    'При загрузке типов квитанций произошла ошибки',
    []
  );
};

const useReceiptTypes = () =>
  useQuery([queries.facilityTariffs], () => getReceiptTypes(), {
    placeholderData: [],
  });

export default useReceiptTypes;
